import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from './general-catalog-select.service';

export interface ServiceCoinSelectOption {
  value: string;
  label: string;
  /** Código de negocio (ej. SC003 = Operación de caja). */
  code?: string;
}

/**
 * Catálogo de monedas de servicio (`service_coin`).
 * GET {apiUrl}/selects/general-catalogs/service_coin/lists
 */
@Injectable({ providedIn: 'root' })
export class ServiceCoinSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<ServiceCoinSelectOption[]> {
    return this.generalCatalogSelect
      .getListOptionsByPrefix('service_coin')
      .pipe(
        map((options) =>
          options.map((o) => ({
            value: o.value,
            label: o.label,
            code: o.code?.trim() || undefined,
          })),
        ),
      );
  }
}
